"use client";

import Link from "next/link";
import { Search, Bell, LogOut, UserCog, Users } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { salir } from "@/lib/actions-usuarios";
import { inicialesDe } from "@/lib/iniciales";

/** Lo que la barra necesita de quien ha entrado (null: login desactivado). */
export interface UsuarioBarra { nombre: string; email: string; rol: "admin" | "equipo" }

export function Topbar({ gasto, usuario }: { gasto?: React.ReactNode; usuario?: UsuarioBarra | null }) {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-background/80 px-4 backdrop-blur md:px-6">
      <form action="/buscar" className="relative w-full max-w-sm">
        <Search className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input name="q" placeholder="Buscar clientes, campañas, contenido…" className="h-9 pl-8" />
      </form>
      <div className="ml-auto flex items-center gap-2">
        {gasto}
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="size-4" />
          <span className="absolute right-2 top-2 size-1.5 rounded-full bg-primary" />
        </Button>
        {usuario && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="rounded-full outline-none ring-offset-background focus-visible:ring-2" aria-label={`Cuenta de ${usuario.nombre}`}>
                <Avatar className="size-8">
                  <AvatarFallback className="bg-primary/10 text-xs font-medium text-primary">{inicialesDe(usuario.nombre)}</AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <p className="text-sm font-medium">{usuario.nombre}</p>
                <p className="truncate text-xs font-normal text-muted-foreground">{usuario.email}</p>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem asChild>
                <Link href="/cuenta" className="gap-2"><UserCog className="size-4 text-muted-foreground" /> Mi cuenta</Link>
              </DropdownMenuItem>
              {usuario.rol === "admin" && (
                <DropdownMenuItem asChild>
                  <Link href="/usuarios" className="gap-2"><Users className="size-4 text-muted-foreground" /> Usuarios</Link>
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuItem className="gap-2" onSelect={() => { void salir(); }}>
                <LogOut className="size-4 text-muted-foreground" /> Cerrar sesión
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </header>
  );
}
